// extracted by mini-css-extract-plugin
export var bottom = "weekly-report-card-module--bottom--8de58";
export var container = "weekly-report-card-module--container--36816";
export var content = "weekly-report-card-module--content--76de6";
export var dailyReportButton = "weekly-report-card-module--daily-report-button--75e6e";
export var dateText = "weekly-report-card-module--date-text--8a252";
export var dayButton = "weekly-report-card-module--day-button--58011";
export var days = "weekly-report-card-module--days--64b00";
export var daysList = "weekly-report-card-module--days-list--1ecf8";
export var deleteButton = "weekly-report-card-module--delete-button--86453";
export var header = "weekly-report-card-module--header--a5968";
export var open = "weekly-report-card-module--open--7dc5b";
export var sendBox = "weekly-report-card-module--send-box--5e977";
export var sendButton = "weekly-report-card-module--send-button--56d49";
export var sendButtonInner = "weekly-report-card-module--send-button-inner--e7aeb";
export var sendInner = "weekly-report-card-module--send-inner--a3ebc";
export var sent = "weekly-report-card-module--sent--f1aca";
export var timeToSend = "weekly-report-card-module--time-to-send--6c693";
export var toggleBox = "weekly-report-card-module--toggle-box--01258";
export var toggleButton = "weekly-report-card-module--toggle-button--24273";
export var toggleContent = "weekly-report-card-module--toggle-content--ccbeb";
export var toggleIcon = "weekly-report-card-module--toggle-icon--03f3b";